var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"StreamMedia"},[_c('div',{class:{ isAvailable: _vm.stream.isAvailable }},[_c('div',{staticClass:"video-tag",attrs:{"id":(_vm.id + "-" + (_vm.stream.mediaStreamType) + "-" + (_vm.stream.id))}})])])}
var staticRenderFns = []

export { render, staticRenderFns }